import React, { useEffect } from "react";
import TasksData from "../../../services/DatabaseService/TasksData";
import { useState } from "react";
import { CardBody, Col, Input, InputGroup, Row } from "reactstrap";
import { BreadCrumb } from "../component/BreadCrumb";
import { Card } from "reactstrap";
import { Link } from "react-router-dom";
import { formatDateTime } from "./../../../Components/Common/FormatDate";
import ProjectData from "../../../services/DatabaseService/ProjectData";

export default function AllTask() {
  const [tasklist, setTaskList] = useState([]);
  const [projectList, setProjectList] = useState([]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
   
    const fetchData = async () => {
      try {
        const result = await TasksData.gettask();
        setTaskList(result);
      } catch (error) {
        console.log("Error fetching task info", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  // console.log(tasklist)


  // useEffect(() => {
    
  //   const fetchData = async () => {
  //     try {
  //       const result = await ProjectData.getProject();
  //       console.log("Project API Result:", result);  
  //       setProjectList(result);
  //     } catch (error) {
  //       console.log("Error fetching task info", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, []);
  // console.log(result)

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Tasks List" pageTitle="Tasks" />
      </div>
      <Row>
        <Col md={8} xs={10} className="mb-2">
          {/* <InputGroup></InputGroup> */}
          <Input
            placeholder="Search by Task Name"
            // value = {filtertext}
            // onChange={handleFilterChange}
          />
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-lg-flex justify-content-end align-items-end mb-2"
        >
          <button className="btn btn-success px-1 px-sm-2">+Add Task</button>
        </Col>
      </Row>
      
        {/*  */}
      <div className="w-100 p-3 ">
        <Row>
        {tasklist.map((task, index) => (
          <Col lg={6} sm={6} xl={6} key={index}>
            <Card>
              <CardBody>
                <h4 className="card-title mb-2">{task.taskName}</h4>
                <h6 className="card-subtitle font-14 text-muted">
                  Created On : {formatDateTime(task.createdOn)}
                </h6>
              </CardBody>

              <CardBody>
                <p className="card-text">{task.description}</p>
                <hr className="my-3" />
                <h1 className="fs-4 mb-2">Comments</h1>
                <div
                  className="w-100 overflow-auto p-3"
                  style={{ height: "230px" }}
                >
                  {task.comments.map((comment, i) => (
                    <div
                      key={i}
                      className="border border-muted rounded-4 p-3 mb-3 bg-white "
                    >
                     
                      {/* <img
                        src={
                          comment.userImage || "https://via.placeholder.com/40"
                        }
                        alt=""
                        className="rounded-circle me-3"
                        width="30"
                        height="30"
                      /> */}

                      <h1 className="card-title mb-2 fw-bold">
                        {comment.createdBy || "Unknown User"}
                      </h1>
                      
                      <h6 className="card-subtitle font-14 text-muted">
                        {formatDateTime(task.createdOn)}
                      </h6>
                      <hr className="my-3" />

                      <p>{comment.commentText}</p>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
        </Row>
      </div>
      
    </div>
  );
}
